module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/header-image-mobile-02-fddeab1378971b01266c76e85016fc33.jpg";